import Main, { MainProps } from './Main';

export type { MainProps };

export default Main;
